var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorfill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 0C7.93103 0 6.7438 0.236155 5.6361 0.694981C4.5284 1.15381 3.52191 1.82632 2.67412 2.67412C1.82632 3.52192 1.15381 4.5284 0.694981 5.6361C0.236155 6.7438 0 7.93103 0 9.13C-7.20471e-07 10.3285 0.236227 11.5152 0.695175 12.6224C1.15412 13.7295 1.82679 14.7354 2.67472 15.5824C3.52265 16.4294 4.52921 17.1009 5.63686 17.5587C6.7445 18.0164 7.9315 18.2513 9.13 18.25C10.329 18.2513 11.5165 18.0165 12.6247 17.5589C13.7329 17.1012 14.7401 16.4298 15.5888 15.583C16.4375 14.7361 17.1112 13.7303 17.5712 12.6231C18.0312 11.5159 18.2687 10.329 18.27 9.13C18.2673 6.70765 17.3032 4.38543 15.5894 2.67351C13.8756 0.961587 11.5523 -1.44982e-06 9.13 0ZM14.03 13L13.5 13.53L12.96 14.06L9.13 10.22L5.3 14.06L4.77 13.53L4.24 13L8.07 9.17L4.24 5.33L5.3 4.33L9.13 8.16L12.96 4.33L13.5 4.85L14.03 5.38L10.2 9.22L14.03 13Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorfill);
export default __webpack_public_path__ + "static/media/Errorfill.0b00759b.svg";
export { ForwardRef as ReactComponent };